import { render, staticRenderFns } from "./orgManage.vue?vue&type=template&id=07f4c422&scoped=true&"
import script from "./orgManage.vue?vue&type=script&lang=js&"
export * from "./orgManage.vue?vue&type=script&lang=js&"
import style0 from "./orgManage.vue?vue&type=style&index=0&lang=less&"
import style1 from "./orgManage.vue?vue&type=style&index=1&id=07f4c422&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f4c422",
  null
  
)

component.options.__file = "orgManage.vue"
export default component.exports